import { ArrowForward } from '@mui/icons-material';
import { useCreatePropertyRequest } from 'hooks/usePropertyRequests';
import { ClipLoader } from 'react-spinners';
import { requestValidationSchemas } from 'schemas/addRequestSchema';
import useAddRequestStore from 'store/addRequestStore';
import { PropertyLeadRequestKeys } from 'types/PropertyLead';
import { urgencyOptions } from 'util/urgencySelector';
import * as yup from 'yup';
interface Props {
    showPreviosButton?: boolean;
}
export default function AddRequestFooterButtons({ showPreviosButton = true }: Props) {
    const {
        setCurrentTabIndex,
        currentTabIndex,
        changeStepStatus,
        steps,
        setRequestPostedModalVisible,
        requestData,
        setErrors,
        errors,
        usePredefinedLocations,
    } = useAddRequestStore();
    const { mutate: createPropertyRequest, isPending } = useCreatePropertyRequest();

    const handleClick = async () => {
        const schema = requestValidationSchemas[currentTabIndex];
        if (schema) {
            try {
                await schema.validate({ ...requestData, usePredefinedLocations }, { abortEarly: false });
                setErrors({} as Record<PropertyLeadRequestKeys, string>);
                changeStepStatus();
                setCurrentTabIndex(currentTabIndex + 1);
            } catch (error) {
                if (error instanceof yup.ValidationError) {
                    const formattedErrors = error.inner.reduce(
                        (acc, err) => {
                            if (err.path) acc[err.path] = err.message;
                            return acc;
                        },
                        {} as Record<string, string>,
                    );

                    setErrors(formattedErrors);
                    return;
                }
            }
        }
    };

    const handleMutate = async () => {
        await createPropertyRequest({
            ...requestData,
            amenities: requestData.amenities ? (requestData.amenities as string[]).join(',') : '',
            commission:
                requestData.commission === 'Custom Percentage' ? requestData.customCommission : Number((requestData.commission as string).replace('%', '')),
            urgency: urgencyOptions.find((option) => option.label === requestData.urgency)?.value as number,
        });
        setRequestPostedModalVisible(true);
    };

    const isDisabledNextButton = Object.values(errors).some((error) => error !== '');
    return (
        <div className="absolute bottom-4 right-8  flex justify-end">
            {showPreviosButton && (
                <button
                    className="py-1 px-6 text-light-black/80 border border-gray-600 rounded-lg font-medium font-poppins text-lg mr-8"
                    onClick={() => {
                        changeStepStatus('backward');
                        setCurrentTabIndex(currentTabIndex - 1);
                    }}
                >
                    Previous
                </button>
            )}
            {isPending ? (
                <ClipLoader loading className="text-my-blue" />
            ) : (
                <button
                    className={`font-semibold font-poppins text-sm text-white bg-my-blue py-2.5 px-20 rounded-lg flex items-center ${isDisabledNextButton ? 'opacity-50' : ''}`}
                    onClick={steps.length - 1 === currentTabIndex ? handleMutate : handleClick}
                    disabled={isDisabledNextButton}
                >
                    {steps.length - 1 === currentTabIndex ? 'Post Request' : 'Next'}
                    {steps.length - 1 !== currentTabIndex && <ArrowForward className="ml-2" />}
                </button>
            )}
        </div>
    );
}
